export default "__VITE_ASSET__6PsImBcp__"